import { z } from "zod";

/**
 * Jenkins validation (Phase 5.5).
 *
 * Boundary validation for the jobs-list query. Filters/sort mirror the legacy
 * client-side controls in `web/js/jenkins.js`:
 *   • free-text search;
 *   • filter tab (all | scheduled | manual);
 *   • sort by any of the table columns, asc/desc.
 */

export const JENKINS_FILTERS = ["all", "scheduled", "manual"] as const;
export const jenkinsFilterSchema = z.enum(JENKINS_FILTERS);

export const JENKINS_SORT_COLUMNS = [
  "name",
  "folder",
  "schedule",
  "cron",
  "health",
  "runtime",
  "countdown",
] as const;
export const jenkinsSortColumnSchema = z.enum(JENKINS_SORT_COLUMNS);

// `sortDirectionSchema` is already exported from ./server.js under the package
// barrel; use a local alias here to avoid a duplicate re-export.
const directionSchema = z.enum(["asc", "desc"]);

/** GET /api/v1/jenkins/jobs querystring. */
export const jenkinsListQuerySchema = z.object({
  search: z.string().trim().max(200).optional(),
  filter: jenkinsFilterSchema.optional(),
  sort: jenkinsSortColumnSchema.optional(),
  direction: directionSchema.optional(),
});

/** POST /api/v1/jenkins/trigger body. An empty body refreshes the snapshot;
 *  jobUrl selects a concrete, already-collected Jenkins job to build. */
export const jenkinsTriggerBodySchema = z
  .object({
    jobUrl: z.string().url().max(2_000).optional(),
  })
  .passthrough();

export type JenkinsListQueryInput = z.infer<typeof jenkinsListQuerySchema>;
export type JenkinsTriggerBodyInput = z.infer<typeof jenkinsTriggerBodySchema>;
